export function removeWrappingQuotes(str) {
  let string = str;
  if (typeof str === 'string' && str.length > 1) {
    string = string.trim();
    if ((string.startsWith('"') && string.endsWith('"')) || (string.startsWith("'") && string.endsWith("'"))) {
      return string.slice(1, -1);
    }
  }
  return string;
}

export function unescapeDoubleQuotes(input) {
  return input.replace(/""/g, '"');
}

export function markdownToPlainText(markdown) {
  return (markdown ?? '')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/^\s*[-*+]\s+/gm, '- ')
    .replace(/^\s*\d+\.\s+/gm, '')
    .trim();
}

export function parseSearchQuery(line, separator = ',') {
  const result = [];
  let current = '';
  let inQuotes = false;
  let fieldStartedWithQuote = false;
  let justClosedQuote = false;

  for (let i = 0; i < line?.length; i++) {
    const c = line[i];

    if (inQuotes) {
      if (c === '"') {
        // escaped quote?
        if (i + 1 < line.length && line[i + 1] === '"') {
          current += '"';
          i++;
        } else {
          // end of quoted section
          current += '"'; // include the closing quote
          inQuotes = false;
          justClosedQuote = true;
        }
      } else {
        current += c;
      }
    } else {
      if (justClosedQuote) {
        // skip stray spaces after closing quote
        if (c === ' ') continue;
        if (c === separator) {
          // end of field
          result.push(formatField(current, fieldStartedWithQuote));
          current = '';
          fieldStartedWithQuote = false;
          justClosedQuote = false;
          continue;
        }
        justClosedQuote = false;
      }

      // Only treat a quote as the start of a quoted field if it is the first non-whitespace character
      if (c === '"' && /^\s*$/.test(current)) {
        inQuotes = true;
        fieldStartedWithQuote = true;
        current = '"'; // include the opening quote
      } else if (c === separator) {
        // end of field
        result.push(formatField(current, fieldStartedWithQuote));
        current = '';
        fieldStartedWithQuote = false;
        justClosedQuote = false;
      } else {
        current += c;
      }
    }
  }

  // final field
  result.push(formatField(current, fieldStartedWithQuote));
  return result;
}

function formatField(field, wasQuoted) {
  if (wasQuoted) {
    // remove wrapping quotes and unescape double quotes for quoted fields
    return unescapeDoubleQuotes(removeWrappingQuotes(field));
  }
  // trim whitespace on unquoted fields
  return field.trim();
}
